import 'css-chunksrc/client/pages/occupancyPage/toolbar/sortDropdown/styles.scss';export default {
  "sortDropdown": "_sortDropdown_1vqy3_1",
  "title": "_title_1vqy3_10",
  "root": "_root_1vqy3_16",
  "input": "_input_1vqy3_20",
  "opened": "_opened_1vqy3_36",
  "icon": "_icon_1vqy3_41",
  "listRoot": "_listRoot_1vqy3_53",
  "list": "_list_1vqy3_53",
  "option": "_option_1vqy3_69",
  "selected": "_selected_1vqy3_75"
};